module.exports = __webpack_public_path__ + "img/Cairo1.448c5c1c.jpg";